// extracted by mini-css-extract-plugin
module.exports = {"collapsible-description":"CollapsibleItem_collapsible-description__jGcC5","collapsible-action":"CollapsibleItem_collapsible-action__8P3R0"};